import './sentry'; // Doit être importé en premier !
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App.jsx';
import SentryFallback from './components/SentryFallback';
import CookieBanner from './components/CookieBanner';
import { getStoredConsent, initTracking } from './lib/tracking';
import { app } from './firebase';
import './index.css';

// Initialisation immédiate si le consentement existe déjà
const consent = getStoredConsent();
if (consent) {
  initTracking(consent, app);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <App />
      <CookieBanner />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
